const CommentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 10 10"
      fill="currentColor"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H8C9.10457 0 10 0.89543 10 2V6C10 7.10457 9.10457 8 8 8H5.65139L2.77735 9.91603C2.62392 10.0183 2.42665 10.0278 2.26407 9.94084C2.10149 9.85383 2 9.6844 2 9.5V8C0.895431 8 0 7.10457 0 6V2ZM2 1C1.44772 1 1 1.44772 1 2V6C1 6.55228 1.44772 7 2 7H2.5C2.77614 7 3 7.22386 3 7.5V8.56574L5.22265 7.08397C5.30478 7.02922 5.40129 7 5.5 7H8C8.55228 7 9 6.55228 9 6V2C9 1.44772 8.55228 1 8 1H2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CommentIcon;
